import { MoneyValue } from '@client/api';

import { CurrencyCode, toCurrencyString, toCurrencyStringOrUndefined } from '../numberUtils';

export const toMoneyString = (value: MoneyValue, placeholder?: string) =>
  toCurrencyString(value.amount, placeholder, {
    currency: (value.currency.code as CurrencyCode) || 'EUR',
  });

export const toMoneyStringOrUndefined = (value?: MoneyValue | null, placeholder?: string) =>
  toCurrencyStringOrUndefined(value?.amount ?? undefined, placeholder, {
    currency: (value?.currency.code as CurrencyCode) || 'EUR',
  });
